/**
 * Generated from ch4_p08.fla
 */
export function ch4_p08(this: Ich4_p08) {
	const bg = this.bg;
	ch4_p08_hh_ch4_p08psdAssetchp4_p08_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const guitar = this.guitar;
	ch4_p08_hh_ch4_p08psdAssetchp4_p08_guitar.call(this.guitar);
	guitar.x = 579;
	guitar.y = 494;
	guitar.width = 159.00;
	guitar.height = 351.00;
	guitar.alpha = 1.00;
	if (guitar.onLayout) guitar.onLayout();
	const basket = this.basket;
	ch4_p08_hh_ch4_p08psdAssetchp4_p08_basket.call(this.basket);
	basket.x = 1021;
	basket.y = 660.25;
	basket.width = 259.00;
	basket.height = 215.50;
	basket.alpha = 1.00;
	if (basket.onLayout) basket.onLayout();
	const holly = this.holly;
	ch4_p08_hh_ch4_p08psdAssetchp4_p08_holly.call(this.holly);
	holly.x = 736;
	holly.y = 729.5;
	holly.width = 238.00;
	holly.height = 552.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const phone = this.phone;
	ch4_p08_hh_ch4_p09psdAssetchp4_p09_phone.call(this.phone);
	phone.x = 950.5;
	phone.y = 384;
	phone.width = 1341.00;
	phone.height = 768.00;
	phone.alpha = 1.00;
	if (phone.onLayout) phone.onLayout();
	const notification = this.notification;
	ch4_p08_hh_ch4_p09psdAssetchp4_p09_notification.call(this.notification);
	notification.x = 838.25;
	notification.y = 371.75;
	notification.width = 298.50;
	notification.height = 148.50;
	notification.alpha = 1.00;
	if (notification.onLayout) notification.onLayout();
	const shine = this.shine;
	ch4_p08_hh_ch4_p09psdAssetchp4_p09_shine.call(this.shine);
	shine.x = 869.25;
	shine.y = 401.5;
	shine.width = 409.50;
	shine.height = 563.00;
	shine.alpha = 1.00;
	if (shine.onLayout) shine.onLayout();
	const frameRight = this.frameRight;
	ch4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeR.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeL.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const lines = this.lines;
	ch4_p08_hh_ch4_p08psdAssetchp4_p08_wcframelines.call(this.lines);
	lines.x = 38.25;
	lines.y = 378.5;
	lines.width = 76.50;
	lines.height = 626.00;
	lines.alpha = 1.00;
	if (lines.onLayout) lines.onLayout();
	return this;
}
function ch4_p08_hh_ch4_p08psdAssetchp4_p08_bg(this: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p08_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p08_hh_ch4_p08psdAssetchp4_p08_guitar(this: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_guitar) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p08_guitar", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p08_hh_ch4_p08psdAssetchp4_p08_basket(this: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_basket) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p08_basket", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p08_hh_ch4_p08psdAssetchp4_p08_holly(this: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p08_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p08_hh_ch4_p09psdAssetchp4_p09_phone(this: Ich4_p08_hh_ch4_p09psdAssetchp4_p09_phone) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p09_phone", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p08_hh_ch4_p09psdAssetchp4_p09_notification(this: Ich4_p08_hh_ch4_p09psdAssetchp4_p09_notification) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p09_notification", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p08_hh_ch4_p09psdAssetchp4_p09_shine(this: Ich4_p08_hh_ch4_p09psdAssetchp4_p09_shine) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p09_shine.png", 0.551, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeR(this: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeR) {
	if (this.setLayoutTexture) this.setLayoutTexture("R", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeL(this: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeL) {
	if (this.setLayoutTexture) this.setLayoutTexture("L", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p08_hh_ch4_p08psdAssetchp4_p08_wcframelines(this: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_wcframelines) {
	if (this.setLayoutTexture) this.setLayoutTexture("lines", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich4_p08Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich4_p08Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich4_p08Sprite extends Ich4_p08Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich4_p08Text extends Ich4_p08Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich4_p08Polygon extends Array<number> {
}
interface Ich4_p08 {
	readonly bg: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_bg;
	readonly guitar: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_guitar;
	readonly basket: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_basket;
	readonly holly: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_holly;
	readonly phone: Ich4_p08_hh_ch4_p09psdAssetchp4_p09_phone;
	readonly notification: Ich4_p08_hh_ch4_p09psdAssetchp4_p09_notification;
	readonly shine: Ich4_p08_hh_ch4_p09psdAssetchp4_p09_shine;
	readonly frameRight: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeR;
	readonly frameLeft: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeL;
	readonly lines: Ich4_p08_hh_ch4_p08psdAssetchp4_p08_wcframelines;
}
interface Ich4_p08_hh_ch4_p08psdAssetchp4_p08_bg extends Ich4_p08Sprite {
}
interface Ich4_p08_hh_ch4_p08psdAssetchp4_p08_guitar extends Ich4_p08Sprite {
}
interface Ich4_p08_hh_ch4_p08psdAssetchp4_p08_basket extends Ich4_p08Sprite {
}
interface Ich4_p08_hh_ch4_p08psdAssetchp4_p08_holly extends Ich4_p08Sprite {
}
interface Ich4_p08_hh_ch4_p09psdAssetchp4_p09_phone extends Ich4_p08Sprite {
}
interface Ich4_p08_hh_ch4_p09psdAssetchp4_p09_notification extends Ich4_p08Sprite {
}
interface Ich4_p08_hh_ch4_p09psdAssetchp4_p09_shine extends Ich4_p08Sprite {
}
interface Ich4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeR extends Ich4_p08Sprite {
}
interface Ich4_p08_hh_ch4_p08psdAssetchp4_p08_wcframeL extends Ich4_p08Sprite {
}
interface Ich4_p08_hh_ch4_p08psdAssetchp4_p08_wcframelines extends Ich4_p08Sprite {
}
